import React from 'react';
import Button from 'material-ui/Button';

import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';

const SideMenu = ({ history, app_store }) => {

    if (!app_store.show_menu) {
        return null;
    }

    const gotoPage = path => {
        history.push(path);
    }

    const getColor = path => {
        if(path === history.location.pathname) {
            return 'primary';
        }
    }

    return (
        <div className="side-menu">
            {
                !app_store.configurations.use_temperature &&
                (
                    <Button title="Dashboard" color={getColor('/dashboard')}
                            onClick={gotoPage.bind(this, '/dashboard')}>
                        <i className="material-icons">dashboard</i> Dashboard
                    </Button>
                )
            }

            <Button title="Monitoramento" color={getColor('/')} onClick={gotoPage.bind(this, '/')}>
                <i className="material-icons">developer_board</i> Monitoramento
            </Button>

            <Button title="Timeline" color={getColor('/timeline')} onClick={gotoPage.bind(this, '/timeline')}>
                <i className="material-icons">timeline</i> Timeline
            </Button>

            {
                app_store.configurations.use_temperature &&
                (
                    <Button title="Temperatura" color={getColor('/temperature')}
                        onClick={gotoPage.bind(this, '/temperature')}>
                        <i className="fa fa-thermometer-full"></i> Temperatura
                    </Button>
                )
            }

            <Button title="Rastreamento" color={getColor('/tracking')} onClick={gotoPage.bind(this, '/tracking')}>
                <i className="material-icons">track_changes</i> Rastreamento
            </Button>

            <Button title="Logs do Sistema" color={getColor('/logs')} onClick={gotoPage.bind(this, '/logs')}>
                <i className="material-icons">data_usage</i> Logs do Sistema
            </Button>

            <Button title="Motoristas" color={getColor('/vehicles')} onClick={gotoPage.bind(this, '/vehicles')}>
                <i className="material-icons">directions_car</i> Motoristas
            </Button>
        </div>
    );

}

let container = observer(SideMenu);
container = inject(['app_store'])(container);

export default withRouter(container);




// WEBPACK FOOTER //
// ./src/components/SideMenu.js